import React from "react";
import BaseCard from "./BaseCard";
import InputTypesEnum from "../../../../Enums/InputTypesEnum";
import CardHeader from "./CardHeader";
import NoteCard from "./NoteCard";
import DataTable from "../../../../Elements/DataTable/DataTableFigma";
import FieldTypesEnum from '../../../../Enums/FieldTypesEnum';
import moneyHelper from '../../../../Helpers/moneyHelper';

class EditingCostCard extends BaseCard {
  render() {
    const { Tier } = this.props;

    return (
      <div className='card'>
        {
          <CardHeader
            bodyactive={this.state.bodyactive}
            changeBodyStatus={this.changeBodyStatus}
            headerClassName='font--withAlert'
            sectionNumber={'6'}
            HeaderText={
              <>
                Editing cost{' '}
                <span className='header-alert'>
                  &gt;&gt;&gt; AI Editing cost is 0.45 USD per report, and it MUST be prioritized. (Please adjust to local
                  currency)
                </span>
              </>
            }
            subtotal={moneyHelper.toMoneyFormat(this.props.Tier.EditingCostTotal, this.props.Tier.PricingDetails.CurrencyCode)}
            subtotalRev={this.props.Tier.EditingCostPct + ' of revenue'}
          />
        }
        {this.state.bodyactive ? (
          <div>
            <NoteCard
              name='EditingCostNotes'
              noteActive={this.state.noteActive}
              renderInputField={this.renderInputField}
              value={this.props.Tier.PricingDetails}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTable,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              DataTableType='Header'
              renderInputFieldFunction={this.renderInputField}
              thereIsNoSuchRowMessageCheck={false}
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableEditorCost,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier.PricingDetails}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableTransCost,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier.PricingDetails}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
            <DataTable
              itemList={Tier.PricingDetails}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableExtDataCheck,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
            />
          </div>
        ) : null}
        <footer>
          <DataTable
            type={{
              FieldsToShowInDataTable: this.FieldsToShowInFooterDataTable,
              MoneyFields: this.MoneyFields,
              Currency: this.Currency,
            }}
            headeritemList={Tier}
            DataTableType='Header'
            thereIsNoSuchRowMessageCheck={false}
            smallDataTable={true}
          />
        </footer>
      </div>
    );
  }

  FieldsToShowInDataTable() {
    return [
      { label: ' ', tableminWidth: '500px', headerPosition: 'header-text-right' },
      { label: 'Per evaluation', tableminWidth: '125px' },
      { label: 'budget per cycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: 'Annually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: '% of revenues', tableminWidth: '125px', headerPosition: 'header-text-right' },
    ];
  }
  FieldsToShowInFooterDataTable() {
    return [
      { label: 'TOTAL EDITING COST', tableminWidth: '750px', headerPosition: 'header-text-right' },
      { label: '', data: 'EditingCostTotal', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: '', data: 'EditingCostPct', tableminWidth: '125px', headerPosition: 'header-text-right' },
    ];
  }
  FieldsToShowInDataTableEditorCost = () => {
    return [
      { label: 'Editor Cost', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '500px' },
      {
        label: 'Per evaluation',
        data: 'EditorCostPerEval',
        type: InputTypesEnum.NumberWithTwoDecimalPlaces2,
        tableminWidth: '125px',
        fieldType: 'Decimal',
      },
      {
        label: 'budget per cycle',
        data: 'EditorCostPerCycle',
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      { label: 'Annually', data: 'EditorCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: '% of revenues',
        type: InputTypesEnum.TextReadOnly,
        data: 'EditorCostPct',
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  };
  FieldsToShowInDataTableTransCost() {
    return [
      { label: 'Translation Cost', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '500px' },
      {
        label: 'Per evaluation',
        data: 'TransCostPerEval',
        type: InputTypesEnum.NumberWithTwoDecimalPlaces2,
        tableminWidth: '125px',
        fieldType: 'Decimal',
      },
      {
        label: 'budget per cycle',
        data: 'TransCostPerCycle',
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      { label: 'Annually', data: 'TransCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: '% of revenues',
        data: 'TransCostPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
  FieldsToShowInDataTableExtDataCheck() {
    return [
      { label: 'DATA ENTRY/ Datachecker', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '500px' },
      {
        label: 'Per evaluation',
        data: 'ExtDataCheckPerEval',
        type: InputTypesEnum.NumberWithTwoDecimalPlaces2,
        tableminWidth: '125px',
        fieldType: 'Decimal',
      },
      { data: 'ExtDataCheckPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: 'ExtDataCheckAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        data: 'ExtDataCheckPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
}

export default EditingCostCard;
